import { Dashboard } from './dashboard.component';

const content: Dashboard = { widgets: [] };

export default content;
